/*
* Free but Trial worlflow configurator
* This is a new workflow being introduced for trial users who started as free users
* These users will get a new marketing work flow
* This flow is for free but trial users.
*/
define('setup/configurators/free-trial-wf-configurator',['require','i18next','./configurator','lodash'],function (require) {
    var i18n = require('i18next');
    var configurator = require('./configurator');
    var _ = require('lodash');

    function FreeTrialPlanConfigurator(options) {
        this.options = options ? _.cloneDeep(options) : {};
        this.completeUrl = options.completeUrl || '';
        this.nextUrl = '#setup/reserve-g2mm';
    }

    // we are implementing the configurator interface
    FreeTrialPlanConfigurator.prototype = Object.create(configurator);

    FreeTrialPlanConfigurator.prototype.setCompleteUrl = function (url) {
        this.completeUrl = url;
    };

    FreeTrialPlanConfigurator.prototype.get = function () {
        var totalSteps = 2;
        var initialPage = 'setup/free-trial';

        // check status of relevant services before deciding
        // on which pages to show
        if (this.options.goToMeetMeDown) {
            initialPage = '';
            totalSteps--;
        }

        return {
            workflowName: 'free-trial-workflow',
            initialPage: initialPage,
            totalSteps: totalSteps,
            isG2MMSchedulingTest: this.options.isG2MMSchedulingTest,
            'free-trial': {
                currentStep: 1,
                pageDescription: i18n.t('setup.freeTrial.descriptionHeaderText'),
                nextUrl: this.nextUrl
            },
            'reserve-g2mm': {
                currentStep: 2,
                pageDescription: i18n.t('setup.reserveG2mm.personalMeetingPage'),
                nextUrl: '/'
            }
        };
    };

    return FreeTrialPlanConfigurator;
});


